"use client";

/**
 * AI-avatar heading that wraps each graph prompt
 */

import type { ReactNode } from "react";
import { ElionE } from "../lib/icons";

export interface PromptHeaderProps {
  title: string;
  subtext?: string;
  children: ReactNode;
}

export function PromptHeader({ title, subtext, children }: PromptHeaderProps) {
  return (
    <>
      <div className="mb-[18px] flex items-start gap-3">
        <div className="mt-0.5 flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full bg-(--brand-navy) text-white">
          <ElionE size={16} />
        </div>
        <div>
          <h2 className="m-0 !text-[22px] !leading-[1.2] font-bold !tracking-[-0.02em] text-(--fg-primary)">
            {title}
          </h2>
          {subtext && (
            <p className="mt-[7px] text-[14px] leading-[1.55] text-(--fg-secondary)">
              {subtext}
            </p>
          )}
        </div>
      </div>
      <div className="flex flex-col gap-2">{children}</div>
    </>
  );
}
